import React, { useEffect, useState } from "react";
import { getAllBlogSlugs } from "../../lib/api";

async function isLive(path: string): Promise<boolean> {
  // const res = await fetch(`/${path}`);
  // if (res.status != 200) console.log(path + " - 404");
  // return res.status == 200;

  const res = await fetch(`https://randomuser.me/api/?results=10`);
  const data = await res.json();
  return data.results;

}

async function revalidate(path: string): Promise<boolean> {
    const resp = await fetch(`/api/revalidate-slug?slug=${path}`);
    if (resp.status != 200) console.log(path + " - 404 after revalidation");
    return resp.status == 200;
}

// async function Check() {
//   const checkBlogURLS = async () => {
//     const newBlogsData = await getAllBlogSlugs();
//     const a = newBlogsData.edges.map(async ({ node }) => {
//       const path = `${node.uri}`;
//       if (!(await isLive(path))) await revalidate(path);
//     });
//     console.log(a);
//   };
//   const checkCelebURLS = async () => {
//     console.log("Pending");
//   };

function Check() {

  const [blogTableData, setBlogTableData] = useState<any[]>([]);

    const checkBlogURLS = async () => {

        const newBlogsData = await getAllBlogSlugs();
        //console.log(newBlogsData.edges);
        
        const a = newBlogsData?.edges.map(async ({ node }) => {
            const path = `${node.uri}`;
            //console.log(node.slug)    
            // if (!(await isLive(path))) await revalidate(path); 
            console.log(isLive(path));   
        });

        // const b = newBlogsData?.edges.map(async ({ node }) => {
        //   const path = `${node.uri}`;
        //   if (!(await isLive(path))) await revalidate(path);
        // });
        // console.log(b);
             
        setBlogTableData(newBlogsData);        

    };
  
  return (
    <div className="container-fluid mt-5">
      <div className="row">
        <div className="col-md-6">
          <h2 style={{ textAlign: "center" }}>Blogs Check</h2>
          <button
            onClick={checkBlogURLS}
            className="loadMore mb-5"
            style={{ margin: "0 auto" }}
          >
            Check Now
          </button>

          <pre>
          {blogTableData}
          </pre>

        </div>
        <div className="col-md-6" style={{borderLeft: '1px solid #ccc'}}>
          <h2 style={{ textAlign: "center" }}>Celebrity Check</h2>
          {/* <button
            onClick={checkCelebURLS}
            className="loadMore mb-5"
            style={{ margin: "0 auto" }}
          >
            {" "}
            Check
          </button> */}
        </div>
      </div>
    </div>
  );
}

export default Check;
